// Include the different bits needed in this page
// @codekit-prepend "./util/util"
// @codekit-prepend "./lib/swiper.min.js"

// Initialize the two galleries for the about section
let About = {

    // Liftoff function
    liftoff : function() {
        this.masonryLayout();
        this.sliderInit()
    },


    // Masonry
    masonryLayout : function(){
        let msnry = new Masonry( '.about-masonry', {
            columnWidth        : '.grid-sizer',
            itemSelector       : '.news-block',
            percentPosition    : true,
            transitionDuration : 0,
            initLayout         : false,
        });



        msnry.on('layoutComplete', function(items) {

            items.forEach(item => {

                if (!item.element.classList.contains('news-block-image')) return;

                let img     = item.element.querySelector('img')
                let caption = item.element.querySelector('.news-block-caption')

                if (img.complete) {
                    caption.style.width = img.width + 'px'
                } else {
                    img.addEventListener('load' , () => {
                        caption.style.width = img.width + 'px'
                    })
                }

            })
        });

        msnry.layout();
    },

    // Init Slider Function
    sliderInit : function() {
        var elem = document.querySelector('.piasentina-reasons-slider');
        var flkty = new Flickity( elem, {
            
            // options
            cellAlign       : 'left',
            contain         : false,
            pageDots        : false,
            prevNextButtons : true,
            imagesLoaded    : true,
            wrapAround      : true,
            setGallerySize  : true,
            arrowShape      : "m68.8425277 0 3.6572417 3.25574375L33.8455689 49.9975485l38.6542807 46.7469016L68.8424476 100 28.8460709 51.6253234l-1.3459205-1.6278591 1.3460006-1.6277877z" 

        });
    }

};

About.liftoff();